import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './IconQuestion.module.css';

const IconQuestion = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg className={classes} width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 9.5V9C9 7.89543 9.89543 7 11 7C12.1046 7 13 7.89543 13 9V9.12132C13 9.68393 12.7765 10.2235 12.3787 10.6213L11 12M11.5 15C11.5 15.2761 11.2761 15.5 11 15.5C10.7239 15.5 10.5 15.2761 10.5 15M11.5 15C11.5 14.7239 11.2761 14.5 11 14.5C10.7239 14.5 10.5 14.7239 10.5 15M11.5 15H10.5M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z" stroke="#0091E8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
};

IconQuestion.defaultProps = {
  rootClassName: null,
  className: null,
};

IconQuestion.propTypes = {
  rootClassName: string,
  className: string,
};

export default IconQuestion;
